import { z } from 'zod';

import { zodUnitMappingsBaseSchema } from '~/data/unit';

export const zodUnitMappingsRouterSearchParamsSchema =
  zodUnitMappingsBaseSchema.extend({
    showForm: z.coerce.boolean().optional().prefault(false),
    unitIdentifier: z.string().trim().optional().prefault(''),
  });
